export const GET_NOTIFICATIONS_START = 'GET_NOTIFICATIONS_START';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR';
export const GET_NOTIFICATIONS_END = 'GET_NOTIFICATIONS_END';

export const ADD_NEW_NOTIFICATION = 'ADD_NEW_NOTIFICATION';

export const ADD_NOTIFICATION_START = 'ADD_NOTIFICATION_START';
export const ADD_NOTIFICATION_ERROR = 'ADD_NOTIFICATION_ERROR';
export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS';

export const MAKE_NOTIFICATIONS_SEEN_START =
  'MAKE_NOTIFICATIONS_SEEN_START';
export const MAKE_NOTIFICATIONS_SEEN_SUCCESS =
  'MAKE_NOTIFICATIONS_SEEN_SUCCESS';
export const MAKE_NOTIFICATIONS_SEEN_ERROR =
  'MAKE_NOTIFICATIONS_SEEN_ERROR';
export const MAKE_NOTIFICATIONS_SEEN_END =
  'MAKE_NOTIFICATIONS_SEEN_END';

export const DELETE_NOTIFICATIONS_START =
  'DELETE_NOTIFICATIONS_START';
export const DELETE_NOTIFICATIONS_SUCCESS =
  'DELETE_NOTIFICATIONS_SUCCESS';
export const DELETE_NOTIFICATIONS_ERROR =
  'DELETE_NOTIFICATIONS_ERROR';
export const DELETE_NOTIFICATIONS_END = 'DELETE_NOTIFICATIONS_END';

export const GET_BULK_PAYMENT_NOTIFICATIONS_START =
  'BulkPaymentCalculationInProgress';
export const GET_BULK_PAYMENT_NOTIFICATIONS_SUCCESS =
  'GET_BULK_PAYMENT_NOTIFICATIONS_SUCCESS';
export const GET_BULK_PAYMENT_NOTIFICATIONS_ERROR =
  'GET_BULK_PAYMENT_NOTIFICATIONS_ERROR';
export const GET_BULK_PAYMENT_NOTIFICATIONS_END =
  'BulkPaymentCalculationDone';
